import React from "react"
import Cabecalho from "../Cabecalho"
import { BairrosEstabelecimentoForm } from "./components/BairrosEstabelecimentoForm"

export function AtribuirBairros() {
    return (
        <>
            <Cabecalho pagina="Áreas de Entrega" />
            <BairrosEstabelecimentoForm />
        </>
    )
}
